import { createGlobalStyles, theme } from '@/theme'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components'

const GlobalStyles = createGlobalStyles()

interface ThemeProviderProps {
  children: React.ReactNode
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <StyledComponentsThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </StyledComponentsThemeProvider>
)
